type ThemeConfig = {
  Development: {
    COMPANY_ID_SUFFIX: { [key: string]: string };
  };
  Production: {
    COMPANY_ID_SUFFIX: { [key: string]: string };
  };
};
const config: ThemeConfig = {
  Development: {
    COMPANY_ID_SUFFIX: {
      cklgcaehs2zri0827i6enc1iz: 'ohpoke',
      cjw6zwz7i2lwk0185z79yx48i: 'babas',
      ckpwm303i1xy50c45kqm51ahi: 'eggs',
      ckp3w5p2h49rj0818o7gxaldd: 'senstreet',
      ckyvm2sqzxqpa09080lposk40: 'tacostudios',
      cl9y0h2t7ere10b46o1670bca: 'nyc',
      clacgfcdf46hw0c55pumqk13t: 'brodernas',
      cldaemmcwhxrn0800ighcmest: 'andysburger',
      cldk7r44l3aus0b413qm4oifj: 'saigonBaguette',
      cldlm4un8582c0c98iexclnrr: 'reloadSuperfoodbar',
      clefjvoxwxis90b41mjv67lpm: 'ubSushi',
      clmhk5cv83wmg0c27xhknmkro: 'umami',
      cln32wxa3i7gw0b37pckzkm2w: 'ilovePizza',
      clnkboqc9sou00b37uwoby7kg: 'fiffis',
      ckmeneb81avc90877is3cslwa: 'baemingo',
    },
  },

  Production: {
    COMPANY_ID_SUFFIX: {
      ckdegsup62nxg07444eiv6o7r: 'ohpoke',
      ck5xzd6gy64rv01282fmspqeg: 'babas',
      ckqtbw4x2h0us0943ph91xbho: 'eggs',
      ckt8aa2xs1i8w0895k5mou96t: 'senstreet',
      cl14qxfhemi0p0c59ohcok0o1: 'nyc',
      cm74ic2ykamnq0968b9psb8la: 'brodernas',
      cld8h9zcglx3d0b872fdyr6c4: 'andysburger',
      cldilk4pdsm260b40jrcun7sm: 'saigonBaguette',
      cldblekufth9j0c33ll64ikew: 'reloadSuperfoodbar',
      clcq5w8v42gpv0b40xbcwid68: 'ubSushi',
      clied01ew8p060c99zc97rkrp: 'umami',
      cldcrd6rl3f8z08362453yepj: 'ilovePizza',
      ckn2wp5d102ep0905v8tyjop5: 'fiffis',
      cl1vtpvb0p9p90975p2bzluvb: 'baemingo',
      clv3kkd51ylmq0995k35uz71s: 'zocalo',
      clv3v4x5hesca0995a6wqcbve: 'zocalo',
      clvat3y1m41vm0c60yzvxzfzw: 'zocalo',
      clv6nuey94udl0b78yrf7rdj2: 'zocaloDK',
      cliocymulte6f0c999yc655ao: 'nemNemQuan',
      clsvxldhjnxwc0843wo6lbcdi: 'greekGrillHouse',
      clxboyh88w0dr0b78fvl0qk5l: 'barcontrol',
      cm7abt7pg3h000a53zj6dz6d4: 'vanadis',
      cldcvacerjtvo0b874nem8gbl: 'wrapsody',
      cmbqdlq9w4iwj0c40nzc1go8x: 'hakee',
      cmcuh31zyd0cu0817fl6jg521: 'thaitec',
      cmcyjkxgqu9rs0c77izyab97k: 'navaraza',
      cmc8kkyk7yajk0817oyipm9e7: 'ryfylkeGardsysteri',
      cmfxpq799b0px0d53fxo20y2q: 'svithunHotel',
      cmhf8rz72zjfn0820n83xu0k5: 'pasterian',
      cmkdzc99g1kdj0c03yevghhs1: 'jettzBurger',
      clwopiz3oplgt0c03naf7mmb5: 'varPizza',
      cmkv49m8ogb0w0886w4hwdwhe: 'trappan',
      cmn5wfwromwod0c84gqb9n4rf: 'kebabdudes',
      cmrvxe94q2igo0c42kwtg4y9u: 'sakura',
      cmseom6wfkogl0c81cooz04j8: 'nollettan',
      cmsykyw8to8gw0d22jtjes79r: 'baoYing',
    },
  },
};

export default config;
